export const strings = {
  password: 'Şifre',
  current_password: 'Mevcut Şifre',
  new_password: 'Yeni Şifre',
  confirm_password: 'Şifreyi onayla',
  save: 'Kaydet',
  update_password: 'Şifreyi Güncelle',
  cancel: 'İptal',

  no_profile: 'Kullanıcı Bulunamadı',
  no_cases: 'Dava/Soru Bulunamadı',
  my_profile: 'Profilim',
  my_account: 'Hesabım',
  profile: 'Profil',
  settings: 'Ayarlar',
  case_template_setup: 'Vaka Şablonu Kurulumu',
  notifications: 'Bildirimler',
  email_address: 'E-posta Adresi',
  title: 'Başlık',
  full_name: 'Ad Soyad',
  first_name: 'İlk adı',
  last_name: 'Soy isim',
  phone_code: 'Telefon Kodu',
  phone_number: 'Telefon Numarası',
  license_id: 'Lisans Kimliği',
  license_id_optional: 'Lisans Kimliği (İsteğe Bağlı)',
  license_status: 'Lisans Durumu',
  speciality: 'Uzmanlık',
  profession: 'Meslek',

  notification_settings: 'Bildirim Ayarları',
  sms_alerts: 'SMS Uyarıları',
  email_alerts: 'E-posta Uyarıları',
  push_notifications: 'Anlık bildirimler (Uygulama içi)',
  reminder_alerts: 'Hatırlatma Uyarıları',
  profile_setup_page_title: 'Profil Kurulumu',
  profile_setup_title: 'Profilim',
  profile_setup_subtitle: 'Neredeyse tamam. Profilinizi tamamlayın.',
  designation: 'Tanımlama',
  enter_designation: 'Tanımı Girin',
  about_me: 'Hakkımda',
  enter_about_me: 'Kendiniz hakkında bir şeyler yazın',
  choose_area_interest: 'İlgi alanınızı seçin',
  your_interests: 'İlgi Alanlarınız',
  retype_password: 'Şifrenizi yeniden yazın',
  enter_current_password: 'Mevcut Şifreyi Girin',
  enter_new_password: 'Yeni Şifreyi Girin',
  enter_retype_password: 'Şifreyi Tekrar Girin',
  change_password_title: 'Şifre değiştir',
  change_password: 'Şifre değiştir',
  change_password_description:
    'Şifreyi değiştirdiğinizde tüm cihazlardan çıkış yapacaksınız ve yeniden giriş yapmanız gerekecek',
  set_password: 'Şifre Ayarla',
  set_password_title: 'Şifre Ayarla',
  set_password_description:
    'İlk defa giriş yaptığınız için bu ekranı görüyorsunuz.',
  errors: {
    current_password_required: 'Mevcut şifrenizi girin',
    new_password_required: 'Şimdi ayarlamak istediğiniz şifreyi girin',
    retype_password_required: 'Ayarlamak istediğiniz şifreyi tekrar yazın',
    retype_password_mismatch: 'Yeni şifre ve şifreyi onayla eşleşmelidir',
    password_length: 'Şifre 8 karakterden uzun olmalı',
    new_password_same: 'Yeni şifre mevcut şifreyle aynı olmamalıdır',
    same_phone_number:
      'Yeni Telefon Numarası mevcut Telefon Numarası ile aynı olmamalıdır',
    no_phone_number: 'Telefon Numarası boş olamaz',
    no_phone_code: 'Telefon Kodu boş olamaz',
    invalid_phone_number: 'Geçerli bir telefon numarası girin',
  },
  about: 'Hakkında',
  about_optional: 'Hakkında (İsteğe Bağlı)',
  contact_details: 'İletişim Detayları',
  enter_otp: 'OTP Girin',
  change_number_title: 'Telefon Numarasını Değiştir',
  submit: 'Göndermek',
  otp_sent_to_email: "E-posta adresinize bir e-posta gönderildi. OTP'yi girin",
  phone_verification_code: 'Telefon Doğrulama Kodu',
  send_verification_code: 'Doğrulama Kodunu Gönder',
  verification_helper_text:
    'Telefon numaranıza gönderilen doğrulama kodu yalnızca 15 dakika geçerli olacaktır!',
  email_verification_helper_text:
    'E-postanıza doğrulama bağlantısı gönderildi. E-postanızı doğrulamak için bağlantıya tıklayın',
  verify: 'Doğrulamak',
  edit: 'Düzenlemek',
  otp_countdown: 'Kod Yeniden Gönder ({num})',
  send_verification_link: 'Doğrulama Bağlantısını Gönder',
  association: 'Bağlılık',
  association_optional: 'Bağlılık (İsteğe Bağlı)',
  license_file: 'Lisans Dosyası',
  country: 'Ülke',
  sign_Out: 'Çıkış yap',
  notice_part1: 'Ülkenizi değiştirmek için lütfen',
  notice_part2: 'iletişime geçin.',
  verified: 'Doğrulandı',
  not_verified: 'Doğrulanmadı',
};
